import React, { useState, useContext, useEffect } from 'react';
import ThemeContext from '../context/theme.Context';
import LoadingContext from '../context/loading.context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from "react-router-dom";
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Spinner from './Spinner.component';
import * as Constants from '../modules/constants';


function ResetPassword(props) {

    const { showLoading, hideLoading } = useContext(LoadingContext);

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [validated, setValidated] = useState(false);
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [resetToken, setResetToken] = useState('');
    const [email, setEmail] = useState('');
    const [resetDone, setResetDone] = useState(false);
    const [resetFailed, setResetFailed] = useState(false);

    const confirmPasswordRef = React.createRef();

    const apiHostName = Constants.API_URL;


    useEffect(() => {
        // Check if we've got the required password reset token and the email address...
        var index = props.location.search.indexOf('token=');
        if (index < 0) {
            // No password reset token specified, redirect to login page...
            props.history.push('/login');
            return;
        }
        var resetToken = props.location.search.substring(index + 6);
        if (resetToken.indexOf('&') >= 0) {
            resetToken = resetToken.substring(0, resetToken.indexOf('&'));
        }
        setResetToken(resetToken);

        index = props.location.search.indexOf('email=');
        if (index < 0) {
            // No email specified, redirect to login page...
            props.history.push('/login');
            return;
        }
        var email = props.location.search.substring(index + 6);
        if (email.indexOf('&') >= 0) {
            email = email.substring(0, email.indexOf('&'));
        }
        setEmail(email);

    }, [setResetToken, setEmail, props.history, props.location.search]);


    // Check that both passwords are identical:
    function updatePassword(value) {
        setPassword(prevstate => {
            confirmPasswordRef.current.setCustomValidity(value === confirmPassword ? '' : "Passwords don't match.");
            return value;
        });
    }
    function updateConfirmPassword(value) {
        setConfirmPassword(prevstate => {
            confirmPasswordRef.current.setCustomValidity(password === value ? '' : "Passwords don't match.");
            return value;
        });
    }


    // If form is valid, submit it to the server:
    function handleSubmit(event) {

        event.preventDefault();
        showLoading();

        // Check form validation
        const form = event.currentTarget;
        setButtonDisabled(true);
        setValidated(true);

        confirmPasswordRef.current.setCustomValidity(password === confirmPassword ? '' : "Passwords don't match.");

        if (form.checkValidity() === false) {
            // Invalid form, so stop processing
            event.stopPropagation();
            setButtonDisabled(false);
            hideLoading();
            return;
        }

        // Ask the server to reset the password:
        fetch(apiHostName + '/v1/users/resetPassword', {
            mode: "cors",
            method: 'PUT',
            cache: "no-cache",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ Email: email, Password: password, ResetToken: resetToken})
        })
            .then(function (response) {
                if (!response.ok) {
                    throw new Error ('Network error');
                }
                return response.text();
            })
            .then((result) => {
                // Result contains a text message that the action was successful - ignore this...
                // Ok, Password is reset - redirect to login form...
                hideLoading();
                setResetDone(true);
            })
            .catch(function (error) {
                // Set visual cue and error text to be displayed on registration screen
                console.error("Cannot reset password...");
                console.error(error);
                hideLoading();
                //setButtonDisabled(false);
                setResetFailed(true);
                setResetDone(true);
            });
    }


    return (
        <ThemeContext.Consumer>
            {(themeContext) => (
                <Row style={{ justifyContent: 'center' }}>
                    <div className="login-card">
                        <div style={{ justifyContent: 'center', display: 'flex' }}>
                            <div className="brand_logo_container">
                                <img src="icon.svg" className="brand_logo" alt="Logo" />
                            </div>
                        </div>

                        <div className="form-container">
                            {!resetDone &&
                                <Form noValidate validated={validated} onSubmit={(event) => { handleSubmit(event); }}>
                                    <Form.Group className="form-title">
                                        <div>Reset password</div>
                                    </Form.Group>

                                    <Form.Group controlId="formPassword">
                                        <InputGroup>
                                            <span className="input-group-text"><FontAwesomeIcon icon="key" /></span>
                                            <Form.Control type="password" name="Password" placeholder="Password" pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?=.*\d).{6,}$" value={password} onChange={(e) => { updatePassword(e.target.value); }} required />
                                            <Form.Control.Feedback type="invalid">
                                                <div className="control-feedback" style={{ color: '#ffffff' }}>Please fill a new password (at least 6 long, with upper- and lowercase, digit and non-alphanumeric character).</div>
                                            </Form.Control.Feedback>
                                        </InputGroup>
                                    </Form.Group>

                                    <Form.Group controlId="formConfirmPassword">
                                        <InputGroup>
                                            <span className="input-group-text"><FontAwesomeIcon icon="key" /></span>
                                            <Form.Control type="password" name="ConfirmPassword" placeholder="Confirm password" value={confirmPassword} ref={confirmPasswordRef} onChange={(e) => { updateConfirmPassword(e.target.value); }} />
                                            <Form.Control.Feedback type="invalid">
                                                <div className="control-feedback" style={{ color: '#ffffff' }}>Please confirm your password.</div>
                                            </Form.Control.Feedback>
                                        </InputGroup>
                                    </Form.Group>

                                    <Form.Group>
                                        <Button className="login-button" disabled={buttonDisabled} type="submit">Reset password <Spinner /></Button>
                                    </Form.Group>
                                </Form>
                            }
                            {resetDone &&
                                <div className="bottom-links">
                                    {resetFailed &&
                                        <div>Your password cannot be reset. Note that a reset password link is only valid once.</div>
                                    }
                                    {!resetFailed &&
                                        <div>Your password has been reset successfully.</div>
                                    }
                                    <div className="bottom-links">Go <Link to="/login">back</Link> to the login screen.</div>
                                </div>
                            }
                        </div>
                    </div>
                </Row>
            )}
        </ThemeContext.Consumer>
    );

}


export default ResetPassword;


// WEBPACK FOOTER //
// ./src/components/ResetPassword.js